import { Badge } from "@/components/ui/badge";

interface PanelEmptyStateProps {
  title: string;
  message: string;
}

export const PanelEmptyState = ({ 
  title, 
  message, 
}: PanelEmptyStateProps) => {
  return (
    <div className="space-y-2">
      <Badge variant="secondary" className="text-xs font-medium text-zinc-500 bg-zinc-50">
        {title}
      </Badge>
      <div className="flex flex-col px-2 rounded-md border-1 border-zinc-500 border-dashed">
        <p className="text-sm text-muted-foreground">{message}</p>
      </div>
    </div>
  );
};
